import * as yup from "yup";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { DateRange } from "react-date-range";
import ReactSelect from "../../../components/common/ReactSelect";
import complianceService from "../../../services/complianceService";
import moment from "moment";

const schema = yup.object({
  status: yup.object({
    label: yup.string(),
    value: yup.string(),
  }),
});

const CorFilterForm = ({ onFilter }) => {
  const [period, setPeriod] = useState([
    {
      startDate: null,
      endDate: new Date(""),
      key: "selection",
    },
  ]);

  const statuses = complianceService.getCORStatuses();

  const {
    register,
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = (data) => {
    let start_date = "";
    let end_date = "";
    let cor_status = "";

    if (period[0].startDate !== null) {
      start_date = moment(period[0].startDate).format("MM-DD-yyyy");
      end_date = moment(period[0].endDate).format("MM-DD-yyyy");
    }

    if (data.status) cor_status = data.status.label;
    if (cor_status === undefined) cor_status = "";

    onFilter(cor_status, start_date, end_date);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <ReactSelect
            id="status-dropdown"
            name="status"
            title="Status"
            options={statuses}
            control={control}
            register={register("status")}
            errors={errors}
          />
        </div>
      </div>
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <label className="form-label">Date Registered</label>
          <DateRange
            startDatePlaceholder="Start Date"
            endDatePlaceholder="End Date"
            editableDateInputs={false}
            moveRangeOnFirstSelection={false}
            onChange={(item) => setPeriod([item.selection])}
            ranges={period}
          />
        </div>
      </div>
      <div className="grid grid-cols-2 mt-12">
        <div className="col-span-2">
          <button type="submit" className="button button-primary">
            Apply Filter
          </button>
        </div>
      </div>
    </form>
  );
};

export default CorFilterForm;
